__turbopack_context__.v({
  "centerArea": "CoopEq_centerArea",
  "leftArea": "CoopEq_leftArea",
  "rightArea": "CoopEq_rightArea",
  "title": "CoopEq_title",
  "wrapper": "CoopEq_wrapper",
});
